var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_setup.error)?_c(_setup.SlimRelatedProductsCarousel,{staticClass:"product__upsellProducts",attrs:{"products-list":_setup.upsellProductsData}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }